<template>
  <div>
    <div class="text-center">
      <h2  class="font-weight-light">Payment Methods</h2>
    </div>

    <v-row 
      justify="center"
      class="ma-5"
    >
      <v-btn
        to="/payment-methods-add"
        color="primary"
        dark
      >
        Add Card
      </v-btn>
    </v-row>

    <v-dialog
      v-model="dialog.show"
      persistent
      max-width="500"
    >
      <v-card>
        <v-card-title
          class="grey lighten-4"
        >
          Remove payment method?
        </v-card-title>

        <v-card-text class="mt-5">
          Removing it means you won’t be able to use this payment method for other Pjili products and services without adding it again
          <p class="display-1 text--primary mt-5">
            {{dialog.brand}}
          </p>
          <p>**** **** **** {{dialog.last4}}</p>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-btn
            @click="dialog.show = false"
            text
            color="blue"
          >
            Cancel
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            v-on:click="delPaymentMethod(dialog.payment_method_id)"
            text
            color="red"
            :loading="dialog.loading"
          >
            Remove
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-container fill-height>
      <v-row>
        <v-col xs="12" sm="6" md="4" lg="3" class="d-flex flex-column" v-for="(pm, index) in paymentMethods" :key="pm.id">
          <v-card class="elevation-5 flex d-flex flex-column">
            <v-card-title primary-title>
              <div v-if="pm.default">
                <v-chip>Default</v-chip>
              </div>
            </v-card-title>
            <v-card-text class="flex">
              <p class="display-1 text--primary">
                {{pm.card.brand}}
              </p>
              <p>**** **** **** {{pm.card.last4}}</p>
              <p>Expires: {{pm.card.exp_month}}/{{pm.card.exp_year}}</p>
            </v-card-text>
            <v-card-actions>
              <v-btn
                v-on:click="showRemoveConfirmation(index)"
                text
                color="red"
              >
                Remove
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn
                text
                color="blue"
                v-on:click="setDefaultPaymentMethod(pm.id)"
                v-if="!pm.default"
              >
                Set Default
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

  </div> 
</template>

<script>

const sleep = (milliseconds) => {
  return new Promise(resolve => setTimeout(resolve, milliseconds))
}

export default {
  name: "PaymentMethods",
  data() {
    return {
      card: '',
      publicToken: '',
      loading: false,
      stripeCustomer: null,
      dialog: {
        payment_method_id: '',
        show: false,
        loading: false,
        brand: '',
        last4: ''
      }, 
      paymentMethods: []
    }
  },
  beforeMount(){
    this.fetchData()
  },
  methods: {
    fetchData(){
      this.$axios.get(this.$cfg.ACCOUNTS_API_URL + 's/customers')
        .then((response)=>{
          this.stripeCustomer = response.data
          return this.$axios.get(this.$cfg.ACCOUNTS_API_URL + 's/paymentmethods')
        })
        .then((response)=>{
          let pms = response.data
          if (pms != null) {
            try{
              // find and set default payment method based on customer object
              pms.forEach((element, index) => {
                if(element.id == this.stripeCustomer.invoice_settings.default_payment_method.id) {
                  pms[index].default = true
                }
              });
            } catch(error){
              pms.forEach((element, index) => {
                pms[index].default = false
              });
            }
          }
          return pms
        })
        .then((data)=>{
          this.paymentMethods = data
        })
        .catch((error) => {
          if (!error.response) {
            this.$store.dispatch("addNotification", {
              type: "error",
              message: "Network Error",
            });
          } else if (error.response.data.errors) {
            this.$store.dispatch("addNotification", {
              type: "error",
              message: error.response.data.errors,
            });
          } else {
            this.$store.dispatch("addNotification", {
              type: "error",
              message: 'Unknown Error, Please contact support.',
            });
          }
        })
    },
    setDefaultPaymentMethod(id){
      this.$axios.post(this.$cfg.ACCOUNTS_API_URL + 's/customers/set-default-payment-method', {id: id})
        .then(()=>{
          this.fetchData()
          this.$store.dispatch("CheckDefaultPaymentMethod")
        })
        .catch((error) => {
          if (!error.response) {
            this.$store.dispatch("addNotification", {
              type: "error",
              message: "Network Error",
            });
          } else if (error.response.data.errors) {
            this.$store.dispatch("addNotification", {
              type: "error",
              message: error.response.data.errors,
            });
          } else {
            this.$store.dispatch("addNotification", {
              type: "error",
              message: 'Unknown Error, Please contact support.',
            });
          }
        })
    },
    delPaymentMethod: function(id) {
      this.dialog.loading = true
      this.$axios.delete(this.$cfg.ACCOUNTS_API_URL + `s/paymentmethods/${id}`)
        .then(()=>{
          sleep(3000).then(() => {  
            this.fetchData()
            this.$store.dispatch("CheckDefaultPaymentMethod")
            this.resetDialog()
            this.loading = false
          })
        })
        .catch((error) => {
          this.loading = false
          if (!error.response) {
            this.$store.dispatch("addNotification", {
              type: "error",
              message: "Network Error",
            });
          } else if (error.response.data.errors) {
            this.$store.dispatch("addNotification", {
              type: "error",
              message: error.response.data.errors,
            });
          } else {
            this.$store.dispatch("addNotification", {
              type: "error",
              message: 'Unknown Error, Please contact support.',
            });
          }
        })
    },
    showRemoveConfirmation: function(id) {
      this.dialog.payment_method_id = this.paymentMethods[id].id
      this.dialog.brand = this.paymentMethods[id].card.brand
      this.dialog.last4 = this.paymentMethods[id].card.last4
      this.dialog.loading = false
      this.dialog.show = true
    },
    resetDialog(){
      this.dialog.payment_method_id = null
      this.dialog.brand = null
      this.dialog.last4 = null
      this.dialog.loading = false
      this.dialog.show = false
    }
  }
}
</script>
